//#region imports
import React, { useEffect, useState, useRef } from 'react'

import useAuth from '../../auth/useAuth';

import {
    settings, getDtRowIndex, getResponse, isUndNullEmpNew, getLanguageObj, LoadingSection, sendMessageCloseCurrentWindow, getError, getProcessButtons,
    isUndNullNew, setBadgeStatusGenericNew, awaitDelay
} from '../../helpers/UtilsHelper';

import Menu from '../main/Menu';
import UserLlmModelSelectAddEdit from './UserLlmModelSelectAddEdit';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';
import { UserLlmModelSelectService } from '../../services/largeLanguageModel/UserLlmModelSelectService';
import { UserLlmClass, UserLlmModelClass, UserLlmModelSelectClass } from '../../classes/ai/UserLLmModelSelectClass';
import HtmlParser from 'react-html-parser';
//#endregion imports

const $ = window.$;

const { app, html, icons, messages, labels, firebase, timers } = settings;
const { fields: dbFields, operators: dbOperators } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'UserLlmModelSelect - function';

export default function UserLlmModelSelect({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let data_ = {};

    const auth = useAuth();
    const selLargeLanguageModelsRef = useRef(null);

    const [largeLanguageModel, setLargeLanguageModel] = useState(LargeLanguageModelClass?.getClass());
    const [largeLanguageModels, setLargeLanguageModels] = useState([]);
    const [userLlmModelSelect, setUserLlmModelSelect] = useState(UserLlmModelSelectClass?.getClass());
    const [provider, setProvider] = useState(UserLlmClass?.getClass());
    const [providerModel, setProviderModel] = useState(UserLlmModelClass?.getClass());
    const [errors, setErrors] = useState({ priority: '' });

    const [process, setProcess] = useState({ showLoading: false, add: false, save: false, selectLargeLanguageModels: false });
    const isMount = useRef(true);

    const dtLlmModelsId = 'dtLlmModelsId';

    //#region variables llmModel (edit)
    const [showModal, setShowModal] = useState(false);
    const [processValues, setProcessValues] = useState({ id: '', description: '', dtId: dtLlmModelsId, dtRowId: 0, type: 0, subMethod: '' })
    const btnEnabledDisabledRef = useRef(null);
    const btnDeleteRef = useRef(null);
    const btnEditRef = useRef(null);
    const methodNames = { changeEnabled: 'changeEnabled' };
    //#endregion variables llmModel edit)
    //#endregion variables

    //#region process
    const setDataTable = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region Datatable
            $(`#${dtLlmModelsId}`).DataTable({
                destroy: true,
                //data: items,
                data: [],
                order: [[1, 'asc']],
                columns: [
                    { title: labels?.code?.[languageObj?.id], width: '70%', orderable: false, },
                    { title: labels?.priority?.[languageObj?.id], className: 'text-center', width: '15%', orderable: true, },
                    { title: labels?.enabled?.[languageObj?.id], className: 'text-center', width: '10%', orderable: false, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtLlmModelsId}_wrapper .col-md-6:eq(0)`);

            //#endregion Datatable

            //#region set query code
            response = setQueryCode({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion set query code
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setDataClear = ({
        dtLlmModelsId_ = false,
        subMethod = '',
    }) => {
        const currentMethod = 'setDataClear';
        let response = getResponse({ type: 0 });
        try {
            if (dtLlmModelsId_) $(`#${dtLlmModelsId}`).DataTable().rows().remove().draw(true);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let description = '';
            let methodValue = '';
            //#endregion variables

            //#region process
            $(`#${dtLlmModelsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndex(dtLlmModelsId, this, currentMethod)?.result;
                if (!isUndNullNew({ data: rowIndex, subMethod: currentMethod })?.result) {
                    methodValue = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodValue) {
                        case 'edit':
                            // await getUserLlmModelSelectAddEditDelete({ e: e, id: id, description: description, rowIndex: rowIndex, type: 1, subMethod: currentMethod });
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: 1, subMethod: currentMethod }));
                            btnEditRef?.current?.click();
                            break;
                        case 'delete':
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: -1, subMethod: currentMethod }));
                            btnDeleteRef?.current?.click();
                            break;
                        case 'changeEnabled':
                            setProcessValues(prev => ({ ...prev, id: id, description: description, dtRowId: rowIndex, type: 2, subMethod: currentMethod }));
                            btnEnabledDisabledRef?.current?.click();
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = await UserLlmModelSelectService?.getAll({
                initialLoad: true,
                token: auth?.account?.tokenVzLaML?.token,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setLargeLanguageModels(response?.result?.largeLanguageModels || []);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDtRow = ({
        data = UserLlmModelClass?.getClass(),
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDtRow';
        let response = getResponse({ type: 0 });
        try {
            const attributes_ = {
                method: methodNames?.changeEnabled,
                id: data?.id,
                description: data?.code
            };
            const value_ = data?.enabled ?
                `<i class='${icons?.fasFa?.toggleOn}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>` :
                `<i class='${icons?.fasFa?.toggleOff}' method='${methodNames?.changeEnabled}' id='${data?.id}' description='${data?.code}'></i>`;

            response.result = [
                data?.code,
                data?.priority,
                setBadgeStatusGenericNew({
                    type: data?.enabled ? 0 : 5,
                    value: value_,
                    title: data?.enabled ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id],
                    attribues: attributes_,
                    pointer: true,
                }),
                getProcessButtons({
                    id: data?.id,
                    description: data?.description,
                    detailsShow: false,
                    detailsLabel: '',
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: false,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: false,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result,
            ];
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const formDataValidate = ({
        userLlmModelSelect = UserLlmModelSelectClass?.getClass(),
        type = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let providers_ = new Set();
            let providerFound_ = UserLlmClass?.getClass();
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            //#endregion variables

            if (type === 1) {
                providerFound_ = null;
                if (isUndNullNew({ data: provider?.priority, subMethod: currentMethod })?.result || provider?.priority <= 0) {
                    setErrors(prev => ({ ...prev, priority: thisFieldRequired }));
                    response = getResponse({ type: 1 });
                }

                // const provider_ = userLlmModelSelect?.providers?.filter(({id: localId}) => localId === provider?.id)?.[0] || {};
                // const providers = userLlmModelSelect?.providers?.filter(({id: localId}) => localId !== provider?.id);
                // provider_.priority = 

                for (const provider_ of userLlmModelSelect?.providers) {
                    if (providers_?.has(provider_?.priority)) {
                        providerFound_ = provider_;
                        break;
                    }
                    providers_.add(provider_?.priority);
                }
                if (providerFound_) {
                    let msgText = `Error: ${messages?.multipleRecordsCannotHaveTheSamePriority?.[languageObj?.id]}<br/>`;
                    msgText += `${labels?.provider?.[languageObj?.id]}: <b>${provider?.id}</b><br/>`;
                    msgText += `${labels?.priority?.[languageObj?.id]}: <b>${providerFound_?.priority}</b><br/>`;
                    setErrors(prev => ({ ...prev, priority: msgText }));
                    response = getResponse({ type: 1 });
                }
            }

            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
    //#endregion process

    //#region large language model (process)
    const getLargeLanguageModel = async ({
        largeLanguageModelId = '',
        showMessage = true,
        subMethod = '',
    }) => {
        const currentMethod = 'getLargeLanguageModel';
        let response = getResponse({ type: 0 });
        try {
            if (showMessage) setProcess(prev => ({ ...prev, showLoading: true, selectLargeLanguageModels: false }));

            //#region variables
            let largeLanguageModel = LargeLanguageModelClass?.getClass();
            //#endregion variables

            //#region clear dataTables
            response = setDataClear({
                dtLlmModelsId_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region process
            if (!isUndNullEmpNew({ data: largeLanguageModelId, subMethod: currentMethod, })?.result) {
                //#region get large language model
                largeLanguageModel = largeLanguageModels.filter(({ id }) => id === largeLanguageModelId)?.[0] || {};
                if (!isUndNullEmpNew({ data: largeLanguageModel, subMethod: currentMethod })?.result) {
                    largeLanguageModel = largeLanguageModel?.[0] || largeLanguageModel;
                }
                //#endregion get large language model

                //#region check status user
                setProcess(prev => ({ ...prev, selectLargeLanguageModels: true }));
                setLargeLanguageModel(largeLanguageModel);
                //#endregion check status user

                //#region get userLlmModelSelect - models
                response = await getUserLlmModelSelect({
                    largeLanguageModelId: largeLanguageModelId,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion get userLlmModelSelect - models
            } else {
                setProvider({});
                setLargeLanguageModel({});
                setErrors(prev => ({ ...prev, priority: '' }));
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (showMessage) setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion large language model (process)

    //#region userLlmModelSelect (process)
    const getUserLlmModelSelect = async ({
        largeLanguageModelId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'getUserLlmModelSelect';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dtRows = [];
            let provider_ = UserLlmClass?.getClass();
            let userLlmModelSelect_ = UserLlmModelSelectClass?.getClass();
            //#endregion variables

            //#region process
            //#region get data (userLlmModelSelect)
            data_ = {
                conditionals: [{ field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid }],
                ordersBy: [],
                limit: 0,
                withDetails: false,
            };

            response = await UserLlmModelSelectService?.getByConditionals({
                data: data_,
                token: auth?.account?.tokenVzLaML?.token,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            userLlmModelSelect_ = response?.result?.userLlmModelSelects?.[0] || {};
            // llmModels_ = response?.result?.llmModels || [];
            setUserLlmModelSelect(userLlmModelSelect_);
            //#endregion get data (userLlmModelSelect)

            //#region set data in dataTable
            provider_ = userLlmModelSelect_?.providers?.find(({ id }) => id === largeLanguageModelId) || {};
            setProvider(provider_);
            const proiderModels_ = provider_?.models || [];
            proiderModels_?.forEach((model) => {
                dtRows.push(
                    setDtRow({
                        data: model,
                        subMethod: currentMethod
                    })?.result
                );
            });

            $(`#${dtLlmModelsId}`).DataTable().rows.add(dtRows).draw(true);
            //#endregion set data in dataTable
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getUserLlmModelSelectAddEditDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = ''
    }) => {
        const currentMethod = 'getUserLlmModelSelectAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: true, add: type === 0 }));

            setProcessValues(prev => ({
                ...prev,
                id: id,
                description: description,
                subMethod: currentMethod,
                dtRowId: rowIndex,
                type: type
            }));

            let userLlmModelSelect_ = UserLlmModelSelectClass?.getClass();

            switch (type) {
                case -1:
                    //#region old code
                    // //#region show message
                    // let msgTextObj = {
                    //     one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                    //     two: `${labels?.model?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    //     three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    // };

                    // let swalProperties = SwalPropertiesClass?.getClass();
                    // swalProperties = {
                    //     icon: sweetAlert2?.icons?.warning,
                    //     title: msgTextObj?.one,
                    //     html: `${msgTextObj?.two}${msgTextObj?.three}`,
                    //     timer: null,
                    //     backdrop: true,
                    //     confirmButtonColor: colors?.warningColorExp,
                    //     confirmButtonText: labels?.yes?.[languageObj?.id],
                    //     showCancelButton: true,
                    //     cancelButtonColor: colors?.successColorExp,
                    //     cancelButtonText: labels?.no?.[languageObj?.id],
                    //     showLoaderOnConfirm: true,
                    //     customClass: {
                    //         popup: html?.popup,
                    //         confirmButton: html?.buttons?.primary,
                    //         cancelButton: html?.buttons?.secondary,
                    //     },
                    //     didOpen: () => {
                    //         Swal.hideLoading();
                    //     },
                    //     allowOutsideClick: () => !Swal?.isLoading(),
                    //     preConfirm: async () => {
                    //         let preConfirmResponse = getResponse({ type: 0 });
                    //         try {
                    //             Swal.getCancelButton().hidden = true;
                    //             Swal.update({
                    //                 icon: sweetAlert2?.icons?.info,
                    //                 title: `${messages?.processing?.[languageObj?.id]}`,
                    //                 html: `${msgTextObj?.two}`,
                    //                 showConfirmButton: false,
                    //             });

                    //             preConfirmResponse = await LlmModelService.delete({
                    //                 id: id,
                    //                 token: auth?.account?.tokenVzLaML?.token,
                    //                 languageId: languageObj?.id,
                    //                 subMethod: currentMethod
                    //             });
                    //             if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                    //             $(`#${dtLlmModelsId}`).DataTable().row(rowIndex).remove().draw(true);
                    //             preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;

                    //             setLlmModels(llmModels?.filter(model => model?.id !== id) || []);
                    //         } catch (ex) {
                    //             preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                    //         }
                    //         return preConfirmResponse;
                    //     }
                    // };
                    // //#endregionshow message

                    // const swalresult = await Swal.fire({
                    //     ...swalProperties,
                    // });
                    // if (swalresult?.isConfirmed && swalresult?.value) {
                    //     response = swalresult?.value;
                    // } else if (swalresult?.isDismissed) {
                    //     response = getResponse({ type: 0 });
                    // }
                    //#endregion old code
                    break;
                case 0:
                    //#region old code
                    // userLlmModelSelect_.llmId = selLargeLanguageModelsRef?.current?.value;
                    // userLlmModelSelect_.userId = auth?.account?.uid;
                    //#endregion old code
                    break;
                case 1:
                    response = await getUserLlmModelSelectById({
                        id: userLlmModelSelect?.id,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                    userLlmModelSelect_ = response?.result || {};

                    const provider_ = userLlmModelSelect_?.providers?.find(({ id: idLocal }) => idLocal === largeLanguageModel?.id) || UserLlmClass?.getClass();
                    const providerModel_ = provider_?.models?.find(({ id: idLocal }) => idLocal === processValues.id) || UserLlmModelClass?.getClass();
                    setProvider(provider_);
                    setProviderModel(providerModel_);
                    setUserLlmModelSelect(userLlmModelSelect_);
                    break;
                default:
                    return;
            }

            if (type === 0) await awaitDelay({ delayTime: timers?.oneSeconds });
            if (type !== -1) setShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (type !== -1) setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getUserLlmModelSelectById = async ({
        id = '',
        subMethod = ''
    }) => {
        const currentMethod = 'getUserLlmModelSelectById';
        let response = getResponse({ type: 0 });
        try {
            return await UserLlmModelSelectService?.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }

    const changeEnabled = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        type = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeEnabled';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let provider_ = UserLlmClass?.getClass();
            let providerModel_ = UserLlmModelClass?.getClass();
            let providerModels_ = [UserLlmModelClass?.getClass()];
            let userLlmModelSelect_ = UserLlmModelSelectClass?.getClass();
            //#endregion variables

            e?.preventDefault();

            id = id !== 'btnSave' ? processValues?.id : id;
            description = processValues?.description;
            rowIndex = processValues?.dtRowId;

            if (!id || rowIndex < 0) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: type === 1 }));

            userLlmModelSelect_ = userLlmModelSelect;
            provider_ = userLlmModelSelect_?.providers?.find(p => p?.id === largeLanguageModel?.id) || {};
            const providers_ = userLlmModelSelect_?.providers?.filter(p => p?.id !== largeLanguageModel?.id) || [];

            if (type === 0) {
                providerModel_ = provider_?.models?.find(({ id: idLocal }) => idLocal === id) || {};
                providerModels_ = provider_?.models?.filter?.(({ id: idLocal }) => idLocal !== id) || [];
                providerModel_.enabled = !providerModel_.enabled;

                provider_.models = [...providerModels_, { ...providerModel_ }];
                provider_.models = provider_?.models?.sort((a, b) => a?.priority - b?.priority);
            } else if (type === 1) { provider_ = provider; }
            userLlmModelSelect_.providers = [...providers_, { ...provider_ }];
            userLlmModelSelect_.providers = userLlmModelSelect_?.providers?.sort((a, b) => a?.priority - b?.priority);
            userLlmModelSelect_.languageId = languageObj?.id;

            if (type === 1) {
                response = formDataValidate({
                    userLlmModelSelect: userLlmModelSelect_,
                    type: type,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return response;
            }

            response = await UserLlmModelSelectService?.update({
                id: userLlmModelSelect_?.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: userLlmModelSelect_,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            userLlmModelSelect_ = response?.result || UserLlmModelSelectClass?.getClass();
            setUserLlmModelSelect(userLlmModelSelect_);

            if (type === 0) {
                provider_ = userLlmModelSelect_?.providers?.find(({ id }) => id === largeLanguageModel?.id) || UserLlmClass?.getClass();
                providerModel_ = provider_?.models?.find(({ id: idLocal }) => idLocal === id) || UserLlmModelClass?.getClass();

                const dtRows = setDtRow({
                    data: providerModel_,
                    subMethod: currentMethod
                })?.result

                $(`#${dtLlmModelsId}`).DataTable().row(rowIndex).data(dtRows).draw(false);
            } else if (type === 1) {
                provider_ = userLlmModelSelect_?.providers?.find(p => p?.id === largeLanguageModel?.id) || {};

                response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
            }

            setProvider(provider_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion userLlmModelSelect (process)

    //#region process (others)
    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion process (others)

    return (
        <div>
            <Menu viewName={urls?.bots?.replaceAll('/', '')} process={urls?.bots?.replaceAll('/', '')} processLevel1={''} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.models?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.models?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.model?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.largeLanguageModels} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.largeLanguageModel?.[languageObj?.id]}</h5>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <form onSubmit={(e) => changeEnabled({ e: e, id: 'btnSave', description: '', rowIndex: 0, type: 1, subMethod: 'btnSave' })}>
                                        <div className='card-body px-4 pb-0'>
                                            <div className='row'>
                                                {/* Select large language model */}
                                                <div className='col-12 col-md-4 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.largeLanguageModel?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.brain} position-absolute input-icon-left`} />
                                                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                                ref={selLargeLanguageModelsRef}
                                                                onChange={(e) => getLargeLanguageModel({ largeLanguageModelId: e?.target?.value, showMessage: true, subMethod: 'getLargeLanguageModel' })}>
                                                                <option defaultValue value=''>{messages?.selectLargeLanguageModel?.[languageObj?.id]}</option>
                                                                {largeLanguageModels?.length > 0 ?
                                                                    largeLanguageModels.map((largeLanguageModel) => (
                                                                        <option key={largeLanguageModel?.id} value={largeLanguageModel?.id}>{` ${largeLanguageModel?.description}`}</option>
                                                                    ))
                                                                    : null
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* code */}
                                                <div className='col-12 col-md-4 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.code?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                                                            <input type='text'
                                                                className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                                placeholder={labels?.code?.[languageObj?.id]}
                                                                value={largeLanguageModel?.code || ''}
                                                                title={labels?.code?.[languageObj?.id]}
                                                                readOnly />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Enabled */}
                                                <div className='col-12 col-md-4 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2 d-none d-md-block'>&nbsp;</label>
                                                        <div className='icheck-primary d-inline-block' style={{ paddingTop: '7px' }}>
                                                            <input type='checkbox'
                                                                id='chkLargeLanguageModelEnabledId'
                                                                checked={provider?.enabled || false}
                                                                disabled={process?.showLoading || !process?.selectLargeLanguageModels}
                                                                onChange={(e) => setProvider(prev => ({ ...prev, enabled: e?.target?.checked }))} />
                                                            <label htmlFor='chkLargeLanguageModelEnabledId' style={{ cursor: 'pointer' }}>
                                                                {labels?.enabled?.[languageObj?.id]}?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-12 col-md-4 mb-3'>
                                                    {/*priority*/}
                                                    <div className='form-group mb-4'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.priority?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                min={0}
                                                                max={99}
                                                                type='number'
                                                                // style={{ height: 'auto', paddingTop: '15px' }}
                                                                title={labels?.priority?.[languageObj?.id]}
                                                                onChange={(e) => setProvider(prev => ({ ...prev, [dbFields?.priority]: parseInt(e?.target?.value || 0) }))}
                                                                placeholder={labels?.priority?.[languageObj?.id]}
                                                                onFocus={() => setErrors(prev => ({ ...prev, priority: '' }))}
                                                                readOnly={process?.showLoading || !process?.selectLargeLanguageModels}
                                                                value={provider?.priority || 0} />
                                                        </div>
                                                        {errors?.priority && <div className={html?.errorText}>{HtmlParser(errors?.priority || '')}</div>}
                                                    </div>

                                                    <div className='form-group'>
                                                        <button ref={btnEnabledDisabledRef}
                                                            className='btn btn-general border border-info shadow-sm font-weight-bold px-4 text-secondary mx-1'
                                                            hidden={true}
                                                            data-title={labels?.edit?.[languageObj?.id]}
                                                            disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                            onClick={(e) => changeEnabled({ e: e })}
                                                            type='button'>
                                                            <i className={`${icons?.fasFa?.edit} mr-2`} />
                                                            {`${labels?.enable?.[languageObj?.id]} / ${labels?.disabled?.[languageObj?.id]}`}
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-4 mb-3'>
                                                    {/* apiKey */}
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.aiApiKey?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.key} position-absolute input-icon-left`} />
                                                            <input type='text'
                                                                className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                                placeholder={labels?.aiApiKey?.[languageObj?.id]}
                                                                value={provider?.apiKey || ''}
                                                                title={labels?.key?.[languageObj?.id]}
                                                                onChange={(e) => setProvider(prev => ({ ...prev, apiKey: e?.target?.value }))}
                                                                readOnly={process?.showLoading || !process?.selectLargeLanguageModels} />
                                                        </div>
                                                    </div>
                                                    <div className='form-group'>
                                                        <button ref={btnDeleteRef}
                                                            className='btn btn-general border border-danger shadow-sm font-weight-bold px-4 text-secondary'
                                                            hidden={true}
                                                            data-title={labels?.delete?.[languageObj?.id]}
                                                            disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                            onClick={(e) => getUserLlmModelSelectAddEditDelete({
                                                                e: e,
                                                                id: processValues?.id,
                                                                description: processValues?.description,
                                                                rowIndex: processValues?.dtRowId,
                                                                type: processValues?.type,
                                                                subMethod: currentMethod
                                                            })}
                                                            type='button'>
                                                            <i className={`${icons?.fasFa?.trashAlt} mr-2`} />
                                                            {labels?.delete?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-4 mb-3'>
                                                    <div className='d-flex align-items-center justify-content-end'>
                                                        <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                                            data-title={labels?.save?.[languageObj?.id]}
                                                            disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                            // onClick={(e) => changeEnabled({ e: e, id: 'btnSave', description: '', rowIndex: 0, type: 1, subMethod: 'btnSave' })}
                                                            // type='button'>
                                                            type='submit'>
                                                            {!process?.save ? (
                                                                <i className={`${icons?.fasFa?.save} mr-1`} />
                                                            ) : (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            )} {labels?.save?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                    <div className='form-group'>
                                                        <button ref={btnEditRef}
                                                            className='btn btn-general border border-warning shadow-sm font-weight-bold px-4 text-secondary mx-1'
                                                            hidden={true}
                                                            data-title={labels?.edit?.[languageObj?.id]}
                                                            disabled={process?.showLoading || !selLargeLanguageModelsRef?.current?.value}
                                                            onClick={(e) => getUserLlmModelSelectAddEditDelete({
                                                                e: e,
                                                                id: processValues?.id,
                                                                description: processValues?.description,
                                                                rowIndex: processValues?.dtRowId,
                                                                type: processValues?.type,
                                                                subMethod: currentMethod
                                                            })}
                                                            type='button'>
                                                            <i className={`${icons?.fasFa?.edit} mr-2`} />
                                                            {labels?.edit?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.model?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.llmModel} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.models?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-4'>
                                        <div className='d-flex flex-wrap justify-content-end align-items-center mb-3' style={{ gap: '8px' }}>
                                            {/* <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading || !process?.selectLargeLanguageModels}
                                                data-title={labels?.add?.[languageObj?.id]}
                                                onClick={(e) => getUserLlmModelSelectAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, type: 0, subMethod: 'btnAiAdd' })}>
                                                {!process?.add ? (
                                                    <i className={`${icons?.fasFa?.plusCircle} mr-1`}></i>
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )}  {labels?.add?.[languageObj?.id]}
                                            </button> */}
                                        </div>
                                        <TableIndex tableId={dtLlmModelsId} languageObj={languageObj} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <UserLlmModelSelectAddEdit $={$}
                            auth={auth}
                            processValues={processValues}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            largeLanguageModel={largeLanguageModel}
                            setLargeLanguageModel={setLargeLanguageModel}
                            userLlmModelSelect={userLlmModelSelect}
                            setUserLlmModelSelect={setUserLlmModelSelect}
                            provider={provider}
                            setProvider={setProvider}
                            providerModel={providerModel}
                            setProviderModel={setProviderModel}
                            setDtRow={setDtRow}
                            languageObj={languageObj} />
                    )}
                </section>
                {/* /.content */}

            </div>
        </div>
    )
}